import React from 'react';
import { useLocation } from 'react-router-dom';
import { findNavContext } from '../../config/navigation';

/**
 * Intestazione standard delle pagine admin: sezione (kicker), titolo, una
 * riga che dice a cosa serve la pagina e le azioni a destra. Il kicker si
 * ricava dalla navigazione, cosi' resta coerente con la sidebar.
 */
interface Props {
    title: React.ReactNode;
    description?: React.ReactNode;
    kicker?: string;
    actions?: React.ReactNode;
    /** Riga di metadati sotto la descrizione (aggiornato alle…, conteggi). */
    meta?: React.ReactNode;
    leading?: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({ title, description, kicker, actions, meta, leading }) => {
    const { pathname } = useLocation();
    const section = kicker ?? findNavContext(pathname).section?.label;

    return (
        <header className="page-header">
            {leading && <div className="page-header__leading">{leading}</div>}
            <div className="page-header__text">
                {section && <div className="page-header__kicker">{section}</div>}
                <h1 className="page-header__title">{title}</h1>
                {description && <p className="page-header__description">{description}</p>}
                {meta && <div className="page-header__meta">{meta}</div>}
            </div>
            {actions && <div className="page-header__actions">{actions}</div>}
        </header>
    );
};

export default PageHeader;

/** Bottone "Aggiorna" usato in quasi tutte le pagine. */
export const RefreshButton: React.FC<{ onClick: () => void; loading?: boolean }> = ({ onClick, loading }) => (
    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClick} disabled={loading}>
        <i className={`bi bi-arrow-clockwise me-1 ${loading ? 'spin' : ''}`} />
        {loading ? 'Aggiorno…' : 'Aggiorna'}
    </button>
);
